import { CommandParametersType } from '@types'

export const mergeAvailableWithConfigured = (
  availableRows: Array<{ key: string; name: string }>,
  configured: CommandParametersType[]
): CommandParametersType[] => {
  const byKey = new Map<string, CommandParametersType>()
  for (const item of configured ?? []) {
    const key = String(item?.title?.id ?? '')
    if (key) byKey.set(key, item)
  }

  return availableRows.map(row => {
    const existing = byKey.get(row.key)

    return (
      existing ?? {
        id: null,
        title: { id: row.key, label: row.name },
        type: null,
        objectCode: null,
        value: '',
        pathArray: null,
      }
    )
  })
}
